import { LogsClient } from './LogsClient';
import { HttpClient } from 'config/apiFunus/generated/http-client';
import axiosInstance from 'config/axios';

const httpClient = new HttpClient();
httpClient.instance = axiosInstance;

export const LogsController = new LogsClient(httpClient);
